module.exports = __webpack_public_path__ + "static/media/sombrero (4).33fffdf8.png";